
import VideoPlayer from '../ui/VideoPlayer.vue'
import LandingList from './LandingList.vue'

export default {
  components: { VideoPlayer, LandingList },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    splitScreen () {
      return this.section.video?.thumbnail || this.section.video?.src
    },

    imageProps () {
      const provider = 'imagekit'

      if (this.section.image) {
        const { image, alt } = this.section.image
        const size = 380

        return {
          provider,
          src: image.data.attributes.url.replace(/^.*\/\/[^/]+/, ''),
          alt,
          width: size,
          height: size,
          quality: 90,
          fit: 'cover'
        }
      }

      return {
        provider,
        src: '/video/placeholder-i18n.jpg',
        width: 432,
        height: 243,
        quality: 90,
        sizes: 'lg:432px xl:576px',
        class: 'hero__image-inner d-block rounded-lg'
      }
    }
  }
}
